var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3763 7.30004C18.2171 6.13954 18.116 4.50526 17.0729 3.46187C15.9447 2.33331 14.1352 2.30137 12.9697 3.37137V3.22232C12.9697 1.58271 11.6392 0.251862 10 0.251862C8.36083 0.251862 7.03034 1.58271 7.03034 3.22232V3.37137C5.86482 2.30669 4.05535 2.33331 2.92709 3.46187C1.87866 4.51058 1.77754 6.13954 2.62374 7.30004C1.14955 7.47039 0 8.72671 0 10.2492C0 11.8888 1.3305 13.2197 2.96967 13.2197H3.11868L2.93241 13.406C1.77222 14.5665 1.77222 16.4456 2.93241 17.6061C4.06599 18.74 5.89675 18.7666 7.05695 17.67C7.24854 19.1233 8.49388 20.2519 10 20.2519C11.5061 20.2519 12.7515 19.1286 12.9431 17.67C14.1086 18.7613 15.934 18.74 17.0676 17.6061C18.2278 16.4456 18.2278 14.5665 17.0676 13.406L16.8813 13.2197H17.0303C18.6695 13.2197 20 11.8888 20 10.2492C19.9947 8.72671 18.8505 7.47039 17.3763 7.30004Z",
    fill: "#ADFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopIcon);
export default __webpack_public_path__ + "static/media/pop_Icon.284e0ecd5f557fd8f3b730fbe4ff8802.svg";
export { ForwardRef as ReactComponent };